<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-info', currentTabIndex === 0)" /> Pendings
        </template>
        <SchedulingPending
          ref="ssPending"
          :tab-index="currentTabIndex"
          @show="showScheduling"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 1)" /> Scheduled
        </template>
        <SchedulingHistory
          ref="ssHistory"
          :tab-index="currentTabIndex"
          @show="showScheduling"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalSchedule"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">

            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transfer Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transfer_number"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Deliver To"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.destination_name"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery From"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.origin_name"
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="2"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Group"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.group_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <BTable
                ref="tableProducts"
                small
                hover
                striped
                bordered
                responsive
                show-empty
                class="mb-0"
                :items="stockRequest.details"
                :busy="tableProducts.busy"
                :filter="tableProducts.filter"
                :fields="tableProducts.fields"
                :stacked="tableProducts.stacked"
                :filter-included-fields="tableProducts.filterOn"
              >
                <template #cell(index)="{ index }">
                  <div
                    class="text-md-nowrap"
                    v-text="tableRowNumber(tableProducts, index)"
                  />
                </template>

                <template #cell()="{ value }">
                  <div
                    class="text-md-nowrap d-flex align-items-center min-h-35px px-1"
                    v-text="value"
                  />
                </template>

                <template #cell(product_name)="{ value }">
                  <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                    <strong
                      class="font-weight-bolder"
                      v-text="value"
                    />
                  </div>
                </template>

                <template #cell(posting_quantity)="{ value }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      class="font-weight-bolder"
                      v-text="value"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center py-5">
                    <BIcon
                      icon="stopwatch"
                      font-scale="5"
                      animation="cylon"
                    />
                    <p class="h3 py-2">
                      <strong>Loading . . .</strong>
                    </p>
                  </div>
                </template>

              </BTable>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Delivery Details</b>
            </div>
          </template>
          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label-for="fCustomerDirect"
                    class="mb-1"
                  >
                    <BFormCheckbox
                      id="fCustomerDirect"
                      v-model="stockRequest.delivery_details.customer_direct"
                      switch
                      value="1"
                      name="customer_direct"
                      unchecked-value="0"
                      disabled
                    >
                      <strong>Direct Deliver to Customer?</strong>
                    </BFormCheckbox>
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvCustomerMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerMobile"
                      v-model="stockRequest.delivery_details.mobile_number"
                      type="text"
                      placeholder="no customer mobile"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Name"
                    label-for="fvCustomerName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvCustomerName"
                      v-model="stockRequest.delivery_details.customer"
                      type="text"
                      placeholder="no customer name"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Address"
                    label-for="fvCustomerAddress"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BTextarea
                      id="fvCustomerAddress"
                      v-model="stockRequest.delivery_details.address"
                      rows="4"
                      max-rows="6"
                      maxlength="50"
                      placeholder="no customer address"
                      disabled
                    />
                  </BFormGroup>
                </BCol>
              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-lg fad fa-calendar-range', {
                  'text-danger fat fa-shake': vTabDeliverySchedule()
                }]"
              />
              <b
                :class="['is-tab-active ml-1', {
                  'text-danger': vTabDeliverySchedule()
                }]"
              >
                Delivery Schedule
              </b>
            </div>
          </template>

          <BRow class="mx-0 mt-1 mb-0">
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <ValidationObserver
                ref="formSchedule"
              >
                <BRow>

                  <BCol
                    cols="12"
                    md="3"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="schedule_details.trip_type"
                      name="trip type"
                      rules="required"
                    >
                      <BFormGroup
                        label="Trip Type"
                        label-for="fTripType"
                        label-class="font-weight-bolder"
                      >
                        <BFormSelect
                          id="fTripType"
                          v-model="stockRequest.schedule_details.trip_type"
                          :options="options.tripTypes"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="(!state.scheduling)"
                        >
                          <template #first>
                            <BFormSelectOption
                              value=""
                              disabled
                            >
                              -- select trip type here --
                            </BFormSelectOption>
                          </template>
                        </BFormSelect>
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                        >
                          <span>{{ errors[0] }}</span>
                        </div>
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                    md="3"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="schedule_details.date"
                      name="date"
                      rules="required"
                    >
                      <BFormGroup
                        :label="tripTypeLabel"
                        label-for="fScheduleDate"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fScheduleDate"
                          v-model="stockRequest.schedule_details.date"
                          type="date"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="(!state.scheduling)"
                        />
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                  >
                    <BRow>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="schedule_details.driver"
                          name="driver"
                          rules="required"
                        >
                          <BFormGroup
                            label="Driver"
                            label-for="fScheduleDriver"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <v-select
                              v-model="selected.driver"
                              input-id="fScheduleDriver"
                              placeholder="search driver here"
                              label="driver_name"
                              clearable
                              append-to-body
                              :options="(options.drivers)"
                              :loading="(state.busy || fetching.drivers)"
                              :disabled="(!state.scheduling || fetching.drivers)"
                              :calculate-position="calculateDropPosition"
                              :class="{ 'is-invalid': errors.length > 0 }"
                            >
                              <template #option="{ driver_name }">
                                <div
                                  class="py-1"
                                  v-text="driver_name"
                                />
                              </template>
                              <template #no-options="">
                                no available driver
                              </template>
                            </v-select>
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="schedule_details.mobile_number"
                          name="mobile number"
                          rules="max:15"
                        >
                          <BFormGroup
                            label="Mobile Number"
                            label-for="fScheduleMobile"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <BFormInput
                              id="fScheduleMobile"
                              v-model="stockRequest.schedule_details.mobile_number"
                              type="text"
                              maxlength="15"
                              placeholder="no mobile number"
                              :state="(errors.length > 0 ? false : null)"
                              disabled
                            />
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>
                    </BRow>
                  </BCol>

                  <BCol
                    cols="12"
                    md="6"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="schedule_details.helper"
                      name="helper"
                      rules="max:50"
                    >
                      <BFormGroup
                        label="Helper"
                        label-for="fScheduleHelper"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fScheduleHelper"
                          v-model="stockRequest.schedule_details.helper"
                          type="text"
                          maxlength="50"
                          :placeholder="(currentTabIndex === 1 ? 'no helper' : 'enter helper here')"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="(!state.scheduling)"
                        />
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                  >
                    <BRow>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="schedule_details.vehicle"
                          name="vehicle"
                          rules="required"
                        >
                          <BFormGroup
                            label="Vehicle"
                            label-for="fScheduleVehicle"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <v-select
                              v-model="selected.vehicle"
                              input-id="fScheduleVehicle"
                              placeholder="search vehicle here"
                              label="vehicle_plate"
                              clearable
                              append-to-body
                              :options="(options.vehicles)"
                              :loading="(state.busy || fetching.vehicles)"
                              :disabled="(!state.scheduling || fetching.vehicles)"
                              :calculate-position="calculateDropPosition"
                              :class="{ 'is-invalid': errors.length > 0 }"
                            >
                              <template #option="{ vehicle_plate, vehicle_name }">
                                <div class="d-flex flex-column py-1">
                                  <span
                                    class="text-wrap"
                                    v-text="vehicle_name"
                                  />
                                  <strong v-text="vehicle_plate" />
                                </div>
                              </template>
                              <template #no-options="">
                                no available vehicle
                              </template>
                            </v-select>
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <BFormGroup
                          label="Vehicle Name"
                          label-for="fScheduleVehicleName"
                          label-class="font-weight-bolder"
                          class="mb-2"
                        >
                          <BFormInput
                            id="fScheduleVehicleName"
                            v-model="stockRequest.schedule_details.vehicle_name"
                            placeholder="no vehicle name"
                            type="text"
                            disabled
                          />
                        </BFormGroup>
                      </BCol>

                    </BRow>
                  </BCol>
                </BRow>
              </ValidationObserver>
            </BCol>

          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>

      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="flex-grow-1 d-flex justify-content-between mb-0 pb-0 gap-2">
          <div />
          <div class="d-flex gap-2">
            <BButton
              v-if="state.scheduling"
              size="sm"
              variant="primary"
              tabindex="-1"
              :disabled="state.busy"
              @click.prevent="$event => validateScheduling($event)"
            >
              Set Schedule
            </BButton>
            <BButton
              size="sm"
              variant="outline-dark"
              tabindex="-1"
              :disabled="state.busy"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import QUERY from 'lodash'
import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import SchedulingPending from '@/views/lo/scheduling/Pending.vue'
import SchedulingHistory from '@/views/lo/scheduling/History.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

import { SSharedList } from '@/services/shared'

export default {
  name: 'VLogisticsOfficerScheduling',

  middleware: ['auth', 'lo'],

  metaInfo: () => ({
    title: 'Scheduling'
  }),

  components: {
    SchedulingPending,
    SchedulingHistory,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER
  ],

  data () {
    return {
      currentTabIndex: this.getCurrentTabIndexByURL(),
      state: {
        busy: false,
        scheduling: false
      },
      fetching: {
        vehicles: false,
        drivers: false
      },
      options: {
        tripTypes: [
          'Delivery',
          'Pick-Up',
          'Inter Branch'
        ],
        vehicles: [],
        drivers: []
      },
      selected: {
        vehicle: '',
        driver: null
      },
      stockRequest: {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          destination: '',
          destination_name: '',
          destination_code: '',
          origin: '',
          origin_name: '',
          origin_code: '',
          group: '',
          group_name: '',
          group_code: ''
        },
        delivery_details: {
          customer_direct: 0,
          customer: '',
          address: '',
          mobile_number: ''
        },
        schedule_details: {
          date: '',
          trip_type: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          helper: ''
        },
        details: [],
        approvals: [],
        remarks: ''
      },
      requesterSignatory: {
        stage: 0,
        approver_label: 'Retail Officer - Origin',
        approver_action: 'Purchase Order',
        approver_name: '',
        last_seen: '',
        status: 'Requested',
        status_at: '',
        remarks: ''
      },
      tableProducts: {
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'posting_quantity', label: 'Quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    tripTypeLabel () {
      return `${this.stockRequest.schedule_details.trip_type || ''} Date`
    },
    ...mapGetters({
      user: 'auth/user'
    })
  },

  watch: {
    'selected.vehicle' (vehicle) {
      this.stockRequest.schedule_details.vehicle = vehicle?.id || ''
      this.stockRequest.schedule_details.vehicle_plate = vehicle?.vehicle_plate || ''
      this.stockRequest.schedule_details.vehicle_name = vehicle?.vehicle_name || ''
    },

    'selected.driver' (driver) {
      this.stockRequest.schedule_details.driver = driver?.id || ''
      this.stockRequest.schedule_details.driver_name = driver?.driver_name || ''
      this.stockRequest.schedule_details.mobile_number = driver?.mobile_number || ''
    }
  },

  methods: {

    vTabDeliverySchedule () {
      return this.$refs.formSchedule && Object.keys(this.$refs.formSchedule.errors).find(
        key => this.$refs.formSchedule.errors[key]?.length > 0
      )
    },

    getCurrentTabIndexByURL () {
      switch (this.$route.params.scheduler) {
        case 'histories' : {
          return 1
        }
        default: {
          return 0
        }
      }
    },

    getVehicles () {
      this.fetching.vehicles = true
      return SSharedList.getVehicles().then(({ data }) => {
        this.options.vehicles = data
      }).catch(() => {
        this.options.vehicles = []
      }).finally(() => {
        this.fetching.vehicles = false
      })
    },

    getDrivers () {
      this.fetching.drivers = true
      return SSharedList.getDrivers().then(({ data }) => {
        this.options.drivers = data
      }).catch(() => {
        this.options.drivers = []
      }).finally(() => {
        this.fetching.drivers = false
      })
    },

    showScheduling (stockRequest, useScheduling) {
      this.state.scheduling = useScheduling

      const { id, approvable } = stockRequest
      const { delivery_details, schedule_details } = approvable

      this.stockRequest = Object.assign(this.stockRequest, {
        id: id,
        stage: approvable.stage,
        references: {
          document_number: approvable.document_number,
          transfer_number: approvable.transfer_number,
          sap_doc_entry: approvable.sap_doc_entry,
          transaction_number: approvable.transaction_number
        },
        headers: {
          destination: approvable.destination_id,
          destination_name: approvable.destination_name,
          destination_code: approvable.destination_code,
          origin: approvable.origin_id,
          origin_code: approvable.origin_code,
          origin_name: approvable.origin_name,
          group: approvable.group_id,
          group_code: approvable.group_code,
          group_name: approvable.group_name
        },
        delivery_details: {
          customer_direct: Number(approvable.customer_direct),
          customer: delivery_details.customer,
          mobile_number: delivery_details.mobile_number,
          address: delivery_details.address
        },
        schedule_details: {
          date: schedule_details?.date || '',
          trip_type: schedule_details?.trip_type || '',
          vehicle: schedule_details?.vehicle || '',
          vehicle_plate: schedule_details?.vehicle_plate || '',
          vehicle_name: schedule_details?.vehicle_name || '',
          driver: schedule_details?.driver || '',
          driver_name: schedule_details?.driver_name || '',
          mobile_number: schedule_details?.mobile_number || '',
          helper: schedule_details?.helper || ''
        },
        details: approvable.transfer_details,
        approvals: approvable.approvals,
        remarks: approvable.remarks,
        created_at: approvable.created_at
      })

      this.requesterSignatory = Object.assign(this.requesterSignatory, {
        approver_name: approvable.destination_name,
        status_at: approvable.created_at
      })

      this.getVehicles().finally(() => {
        this.selected.vehicle = QUERY.find(this.options.vehicles, {
          id: Number(schedule_details?.vehicle)
        })

        this.getDrivers().finally(() => {
          this.selected.driver = QUERY.find(this.options.drivers, {
            id: Number(schedule_details?.driver)
          })
        })
      })

      this.$bvModal.show('modalSchedule')
    },

    validateScheduling ({ target }) {
      this.$refs.formSchedule.validate().then(
        validSchedule => {
          if (!validSchedule) {
            return this.swalInvalid()
          }

          this.swalConfirmWithRemarks({
            html: 'Set the Delivery Schedule?',
            preConfirm: remarks => {
              return this.$refs.ssPending.update({
                id: this.stockRequest.id,
                selected: [
                  {
                    id: this.stockRequest.id,
                    remarks: remarks
                  }
                ],
                schedule_details: this.stockRequest.schedule_details,
                status: 'Scheduled'
              }).catch(errors => {
                this.$refs.formSchedule.setErrors(errors)
              })
            },
            confirmButtonText: target.innerText
          })
        }
      )
    }
  }
}
</script>
